import { render, staticRenderFns } from "./barChart.vue?vue&type=template&id=8df46c48&scoped=true"
import script from "./barChart.vue?vue&type=script&lang=js"
export * from "./barChart.vue?vue&type=script&lang=js"
import style0 from "./barChart.vue?vue&type=style&index=0&id=8df46c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df46c48",
  null
  
)

export default component.exports